import i18next from 'lib/i18next';

// Javascript doesn't have a built-in method for creating a date object
// in UTC from a string, but it can be done by converting to integers
export function getUTCDate(dateString = Date.now()): Date {
  const date = new Date(dateString);

  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}

export function getFullDocumentHeight(): number {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
}

// Simple method for generating a set of localized urls from any
// path.  Useful for things like meta tags, og tags, etc.  Probably
// not useful for links as the url includes the production domain.
export function getLocalizedUrlsFromPath(path = '', host = ''): { en: string; es: string } {
  // strip leading slash
  const barePath = path.replace(/^\//, '');

  return {
    en: `${host}/${barePath}`,
    es: `${host}/es/${barePath}`,
  };
}

export function localizeUrl(path = '', host = '', locale = i18next.language): string {
  const localizedUrls = getLocalizedUrlsFromPath(path, host);
  return (localizedUrls as any)[locale];
}

export function isValidVin(vin: string): boolean {
  const exp = /^[A-HJ-NPR-Z\d]{8}[\dX][A-HJ-NPR-Z\d]{8}$/;
  return !!exp.exec(vin);
}

export function inIframe(): boolean {
  return typeof window !== 'undefined' && window.location !== window.parent.location;
}

export function filterTruthyKeys(obj: { [key: string]: boolean | undefined } | undefined): string {
  if (!obj) return '';
  return Object.keys(obj)
    .filter((key) => obj[key])
    .join(',');
}
